// import { Divider, Grid, IconButton, Paper, Typography } from "@mui/material";
// import React, { useState } from "react";
// import { ReactComponent as ArrowUpwordCorner } from "../../../images/ArrowCorner.svg";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";

// export const LabRecentNotification: React.FC<any> = React.memo((props) => {
//   const filters = ["All", "Payments", "Return"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);

//   // ✅ Notification Data Array (MAP)
//   const notifications = [
//     {
//       icon: <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />,
//       text: "New test order #ORD1085 received for Full Body Checkup. ",
//       time: "3h",
//     },
//     {
//       icon: <WSIcons.TbCalculator style={{ color: "#CEEEE5", fontSize: 20 }} />,
//       text: "Sample collection scheduled tomorrow for Order #ORD1095 ",
//       time: "3h",
//     },
//     {
//       icon: <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />,
//       text: "Report delayed for Order #ORD1088, awaiting results",
//       time: "3h",
//     },
//     {
//       icon: (
//         <WSIcons.BsFileTextFill style={{ color: "#CEEEE5", fontSize: 20 }} />
//       ),
//       text: "COVID-19 RT-PCR for Order #LAB2098. ",
//       time: "3h",
//     },
//     {
//       icon: (
//         <WSIcons.GiEmptyMetalBucket
//           style={{ color: "#F21E1E", fontSize: 20 }}
//         />
//       ),
//       text: "Out of stock: Blood Glucose Test Strips",
//       time: "4h",
//     },
//     {
//       icon: (
//         <WSIcons.GiEmptyMetalBucket
//           style={{ color: "#F9E78C", fontSize: 20 }}
//         />
//       ),
//       text: "Only 10 units left: Lipid Profile Kits.",
//       time: "4h",
//     },
//     {
//       icon: (
//         <WSIcons.GiEmptyMetalBucket
//           style={{ color: "#F9E78C", fontSize: 20 }}
//         />
//       ),
//       text: "Only 5 units left: Paracetamol 500mg. ",
//       time: "4h",
//     },
//     {
//       icon: (
//         <WSIcons.PiShieldWarningFill
//           style={{ color: "#F9E78C", fontSize: 20 }}
//         />
//       ),
//       text: "Reagent batch expiry approaching: TSH Test Kit (exp. in 7 days). ",
//       time: "4h",
//     },
//   ];

//   return (
//     <Paper
//       elevation={0}
//       style={{
//         paddingLeft: 20,
//         paddingRight: 20,
//         marginTop: 40,
//         paddingBottom: 25,
//         borderRadius: "8px",
//       }}
//     >
//       <Grid container spacing={2}>
//         {/* Header */}
//         <Grid item xs={12} sm={10}>
//           <Typography>Recent Notifications</Typography>
//         </Grid>
//         <Grid item xs={12} sm={2}>
//           <ArrowUpwordCorner />
//         </Grid>

//         {/* Filter Buttons */}
//         <Grid item xs={12}>
//           <WSFilterButtonGroup
//             options={filters}
//             selected={selectedFilter}
//             onChange={(value) => {
//               setSelectedFilter(value);
//             }}
//           />
//         </Grid>

//         {/* Today Label */}
//         <Grid item xs={12}>
//           <Typography>Today</Typography>
//         </Grid>

//         {/* Notifications List Using MAP */}
//         {notifications.map((item, index) => (
//           <React.Fragment key={index}>
//             <Grid item xs={12} sm={2}>
//               <IconButton
//                 sx={{
//                   width: 30,
//                   height: 30,
//                   borderRadius: "8px",
//                   border: "1px solid #828584",
//                   p: 0,
//                 }}
//               >
//                 {item.icon}
//               </IconButton>
//             </Grid>

//             <Grid item xs={12} sm={10}>
//               <Typography>
//                 {item.text}{" "}
//                 <span style={{ color: "#828584" }}>{item.time}</span>
//               </Typography>
//             </Grid>

//             <Grid item xs={12}>
//               <Divider />
//             </Grid>
//           </React.Fragment>
//         ))}
//       </Grid>
//     </Paper>
//   );
// });








import { Divider, Grid, IconButton, Paper, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { ReactComponent as ArrowUpwordCorner } from "../../../images/ArrowCorner.svg";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import http from "../../../commonFunctions/httpClient";
import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";

interface Notification {
  id: string;
  title: string;
  body: string;
  isRead: boolean;
  createdAt: string;
}

interface ApiResponse {
  status: boolean;
  data: Notification[];
}

export const LabRecentNotification: React.FC<any> = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(true);
  const [labId, setLabId] = useState<string>("");

  // STEP 1: Get labId
  useEffect(() => {
    console.log("🚀 STEP 1: Loading labId...");
    const userId = getLocalValue(LoacalVariables.UserId);
    console.log("🔑 GOT LAB ID:", userId);
    setLabId(userId || "");
  }, []);

  // STEP 2: Fetch data when labId ready
  useEffect(() => {
    console.log("🚀 STEP 2: labId changed to:", labId);
    if (!labId) return;

    console.log("📡 STEP 3: MAKING API CALL...");
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: any = await http.get(`Notification/Lab/${labId}`);
        console.log("📦 STEP 4: API SUCCESS:", response);
        
        // ✅ TYPE SAFE: Handle both response.data and response directly
        let apiData: Notification[] = [];
        if (response?.data && Array.isArray(response.data)) {
          apiData = response.data;
        } else if (Array.isArray(response)) {
          apiData = response;
        }
        
        console.log("✅ STEP 5: RAW DATA:", apiData);
        if (apiData.length > 0) {
          setNotifications(apiData.slice(0, 8));
          console.log("✅ STEP 6: Notifications set:", apiData.length);
        }
      } catch (error: any) {
        console.error("💥 STEP 7: API ERROR:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [labId]);

  console.log("🎨 STEP 8: RENDERING:", notifications.length, "notifications");

  if (loading) {
    return (
      <Paper elevation={0} style={{ padding: 20, marginTop: 40, borderRadius: "8px" }}>
        <Typography>Loading...</Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={10}>
          <Typography>Recent Notifications ({notifications.length})</Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <ArrowUpwordCorner />
        </Grid>
        <Grid item xs={12}>
          <WSFilterButtonGroup 
            options={["All", "Payments", "Return"]} 
            selected="All" 
            onChange={() => {}} 
          />
        </Grid>
        
        {notifications.length === 0 ? (
          <Grid item xs={12} sx={{ textAlign: 'center', py: 4 }}>
            <Typography color="text.secondary">No notifications</Typography>
          </Grid>
        ) : (
          <>
            <Grid item xs={12}>
              <Typography>Today</Typography>
            </Grid>
            {notifications.map((notification, index) => (
              <React.Fragment key={notification.id || `notif-${index}`}>
                <Grid item xs={12} sm={2}>
                  <IconButton sx={{ 
                    width: 30, 
                    height: 30, 
                    borderRadius: "8px", 
                    border: "1px solid #828584", 
                    p: 0 
                  }}>
                    <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />
                  </IconButton>
                </Grid>
                <Grid item xs={12} sm={10}>
                  <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                    {notification.title} 
                    {notification.body && `- ${notification.body}`}
                    <span style={{ color: "#828584", marginLeft: 8 }}>
                      {notification.createdAt 
                        ? new Date(notification.createdAt).toLocaleString('en-IN', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true
                        })
                        : 'No date'}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </React.Fragment>
            ))}
          </>
        )}
      </Grid>
    </Paper>
  );
};

export default LabRecentNotification;
  